<!-- Billing-address picker — the full list is visible immediately, as
     selectable option rows (the fulfillment step's "Ship to" pattern). -->
<div class="vb-addr-select">
    <span class="vb-addr-select__label">Select billing address</span>

    <div
        class="vb-addr-select__list"
        role="radiogroup"
        aria-label="Billing address"
        *ngIf="sortedAddresses.length > 0">
        <vb-option-row
            *ngFor="let address of sortedAddresses"
            [label]="addressLine1(address)"
            [description]="addressLine2(address)"
            [selected]="isSelected(address)"
            [tag]="isDefaultAddress(address.id) ? 'Default' : null"
            (clicked)="selectAddress(address)">
        </vb-option-row>
    </div>

    <p class="vb-addr-select__empty" *ngIf="sortedAddresses.length === 0">
        No saved addresses yet — add one below.
    </p>
</div>
